import { useEffect } from 'react';

interface IframeProps {
  iframeRef: React.RefObject<HTMLIFrameElement>;
  plexoUrl: string | null;
  replacePaymentMethodPlexoUrl: string | null;
}

function Iframe({ iframeRef, plexoUrl, replacePaymentMethodPlexoUrl }: IframeProps) {
  function onMessage(event: MessageEventInit) {
    var data = event.data;
    if (data && data.plexo && iframeRef && iframeRef.current) {
      console.log(data.plexo.height);
      iframeRef.current.height = data.plexo.height;
    }
  }

  useEffect(() => {
    if (window.addEventListener) {
      window.addEventListener('message', onMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', onMessage, false);
    }

    return () => {
      window.removeEventListener('message', onMessage, false);
    };
  });

  return (
    <iframe
      id="plexoIframe"
      ref={iframeRef}
      height={600}
      width={498}
      className="plexo-frame"
      src={(plexoUrl && plexoUrl) || (replacePaymentMethodPlexoUrl && replacePaymentMethodPlexoUrl) || ''}
      title="Plexo"
    ></iframe>
  );
}

export default Iframe;
